import {
  Company,
  Customer,
  GenericDocuments,
  ILeadAction,
  Lead,
  Lead360Data,
  OwnerUser,
  Proposal,
} from "../../api/models";
import {
  LeadConfiguration,
  LeadConfigurationType,
} from "../../api/models/configuration";
import { LeadRequirement } from "../../api/models/requirement";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";

const ACTION_REQUEST_360_DATA = "360_DATA/REQUEST_360_DATA";
const ACTION_LOADED_360_DATA = "360_DATA/LOADED_360_DATA";
const ACTION_ERROR_360_DATA = "360_DATA/ERROR_360_DATA";
const ACTION_RESET_360_DATA = "360_DATA/RESET_360_DATA";
const ACTION_CONFIGURATION_SAVED = "360_DATA/ACTION_CONFIGURATION_SAVED";

const getConfigurationsByType = (
  configurations: LeadConfiguration[],
  configurationType: LeadConfigurationType
) => {
  return configurations.filter(
    (cnf) => cnf.configurationType === configurationType
  );
};

export interface Lead360State {
  customerId?: string;
  currentSalesPerson?: OwnerUser;
  currentCRMAgent?: OwnerUser;
  loaded?: boolean;
  loading?: boolean;
  error?: any;
  customer?: Customer;
  allLeads?: Lead[];
  leads?: Lead[];
  enquiries?: Lead[];
  leadActions?: { leadId: string; actions: ILeadAction[] }[];
  users?: Customer[];
  company?: Company;
  requirements?: LeadRequirement[];
  proposals?: Proposal[];
  agreements?: GenericDocuments[];
  invoices?: GenericDocuments[];
}

const initialState: Lead360State = {
  loaded: false,
  loading: false,
};

type RequestLead360DataActionType = IActionWithPayload<
  typeof ACTION_REQUEST_360_DATA,
  { customerId: string }
>;

type Lead360DataLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_360_DATA,
  {
    customerId: string;
    data: Lead360Data;
    currentSalesPerson?: OwnerUser;
    currentCRMAgent?: OwnerUser;
  }
>;
type Lead360DataErrorActionType = IActionWithPayload<
  typeof ACTION_ERROR_360_DATA,
  { customerId: string; error: any }
>;

type ResetLead360DataActionType = IAction<typeof ACTION_RESET_360_DATA>;
type ConfigurationSavedActionType = IActionWithPayload<
  typeof ACTION_CONFIGURATION_SAVED,
  LeadRequirement
>;

type Actions =
  | RequestLead360DataActionType
  | Lead360DataLoadedActionType
  | Lead360DataErrorActionType
  | ResetLead360DataActionType
  | ConfigurationSavedActionType;

export const requestLead360DataAction = (data: {
  customerId: string;
}): RequestLead360DataActionType => {
  return createActionWithPayload(ACTION_REQUEST_360_DATA, data);
};

export const lead360DataLoadedAction = (data: {
  customerId: string;
  data: Lead360Data;
  currentSalesPerson?: OwnerUser;
  currentCRMAgent?: OwnerUser;
}): Lead360DataLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_360_DATA, data);
};

export const lead360DataErrorAction = (data: {
  customerId: string;
  error: any;
}): Lead360DataErrorActionType => {
  return createActionWithPayload(ACTION_ERROR_360_DATA, data);
};
export const resetLead360DataAction = (): ResetLead360DataActionType => {
  return createAction(ACTION_RESET_360_DATA);
};

export const configurationSavedAction = (
  config: LeadRequirement
): ConfigurationSavedActionType => {
  return createActionWithPayload(ACTION_CONFIGURATION_SAVED, config);
};

// reducer
export const lead360Reducer = (
  state: Lead360State = initialState,
  action: Actions
): Lead360State => {
  switch (action.type) {
    case ACTION_REQUEST_360_DATA:
      return {
        ...initialState,
        customerId: action.payload.customerId,
        loading: true,
        loaded: false,
        currentCRMAgent: undefined,
        currentSalesPerson: undefined,
      };
    case ACTION_RESET_360_DATA:
      return {
        ...initialState,
      };
    case ACTION_LOADED_360_DATA: {
      const leads = action.payload.data.leads?.filter((lead) => !lead.isDeal);
      const enquiries = action.payload.data.leads?.filter(
        (lead) => lead.isDeal
      );

      return {
        ...state,
        loaded: true,
        loading: false,
        allLeads: action.payload.data.leads,
        leads,
        enquiries,
        leadActions: action.payload.data.leadActions,
        customer: action.payload.data.customer,
        customerId: action.payload.customerId,
        currentSalesPerson: action.payload.currentSalesPerson,
        currentCRMAgent: action.payload.currentCRMAgent,
        company: action.payload.data.company,
        users: action.payload.data.users,
        requirements: action.payload.data.requirements,
        proposals: action.payload.data.proposals,
        agreements: action.payload.data.agreements,
        invoices: action.payload.data.invoices,
      };
    }
    case ACTION_ERROR_360_DATA:
      return {
        ...state,
        loaded: true,
        loading: false,
        customerId: action.payload.customerId,
        error: action.payload.error,
        currentCRMAgent: undefined,
        currentSalesPerson: undefined,
      };
    case ACTION_CONFIGURATION_SAVED: {
      // if (action.payload.customerId !== state.customerId) {
      return {
        ...state,
      };
      // }
      // const allConfigurations = [...(state.allConfigurations || [])].filter(
      //   (c) => c._id !== action.payload._id
      // );
      // allConfigurations.push(action.payload);
      // const allQuotations = getConfigurationsByType(
      //   allConfigurations,
      //   LeadConfigurationType.Quotation
      // );
      // const allConfigurationsByType = getConfigurationsByType(
      //   allConfigurations || [],
      //   LeadConfigurationType.Configuration
      // );
      // return {
      //   ...state,
      //   configurations: allConfigurationsByType?.filter(
      //     (conf) => !conf.isPreBooking
      //   ),
      //   quotations: allQuotations?.filter((conf) => !conf.isPreBooking),
      //   preBookings: [
      //     ...(allConfigurationsByType?.filter((conf) => conf.isPreBooking) ||
      //       []),
      //     ...(allQuotations?.filter((conf) => conf.isPreBooking) || []),
      //   ],
      //   bookings: getConfigurationsByType(
      //     allConfigurations,
      //     LeadConfigurationType.Booking
      //   ),
      //   orders: getConfigurationsByType(
      //     allConfigurations,
      //     LeadConfigurationType.Order
      //   ),
      //   invoices: getConfigurationsByType(
      //     allConfigurations || [],
      //     LeadConfigurationType.Invoice
      //   ),
      //   allConfigurations,
      // };
    }

    default:
      return state;
  }
};
